import { ReactNode } from 'react';

import styles from './suggested-price-detail-row.module.scss';

interface SuggestedPriceDetailRowProps {
  dataTestId?: string;
  description: ReactNode;
  icon: ReactNode;
  title: string;
}

/**
 * One icon + bold title + sentence row. Shared by the drawer's explanation factors (default
 * variant) and its override-impact list (overridden variant), which are visually identical rows
 * fed by different data sources — hence the icon arriving as a node rather than a category key.
 */
export const SuggestedPriceDetailRow = ({
  dataTestId,
  description,
  icon,
  title,
}: SuggestedPriceDetailRowProps) => (
  <div className={styles.row} data-testid={dataTestId}>
    {icon}
    <div className={styles.content}>
      <p className={styles.title}>{title}</p>
      <div className={styles.description}>{description}</div>
    </div>
  </div>
);
